import React, { useCallback, useRef } from 'react';
import { Button } from '@mui/material';

import { ReadFile, SelectFile } from '@paragon/client-tools';

import loadFiles from '../actions/loadFiles';
import { useAppDispatch } from './hooks';

interface Props {
  readonly disabled?: boolean;
}

export function FileImport({ disabled }: Props) {
  const dispatch = useAppDispatch();
  const fileSelect = useRef<SelectFile | null>(null);

  const onFilesLoading = useCallback(
    async (pFilesLoading: readonly Promise<ReadFile>[]) => {
      const files = await Promise.all(pFilesLoading);
      await dispatch(loadFiles(files));
    },
    [dispatch],
  );

  const onClick = useCallback(() => {
    if (disabled) return;
    fileSelect.current!.click();
  }, [disabled]);

  return (
    <Button variant="outlined" onClick={onClick}>
      Choose Files
      <SelectFile
        id="uploadFiles"
        hide
        onChange={onFilesLoading}
        multiple
        accept=".tre,.trs,.tps,.of,.clearspan,.tdltruss,.kxf,.kxr"
        ref={fileSelect}
      />
    </Button>
  );
}
